"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegTweaksTmpClearT = exports.LegTweaksTmpClear = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Clears the legtweaks temporary state back to what the config has.
 * Setting a field to `true` will reset that field.
 */
class LegTweaksTmpClear {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsLegTweaksTmpClear(bb, obj) {
        return (obj || new LegTweaksTmpClear()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsLegTweaksTmpClear(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new LegTweaksTmpClear()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    floorClip() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    skatingCorrection() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    toeSnap() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    footPlant() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startLegTweaksTmpClear(builder) {
        builder.startObject(4);
    }
    static addFloorClip(builder, floorClip) {
        builder.addFieldInt8(0, +floorClip, +false);
    }
    static addSkatingCorrection(builder, skatingCorrection) {
        builder.addFieldInt8(1, +skatingCorrection, +false);
    }
    static addToeSnap(builder, toeSnap) {
        builder.addFieldInt8(2, +toeSnap, +false);
    }
    static addFootPlant(builder, footPlant) {
        builder.addFieldInt8(3, +footPlant, +false);
    }
    static endLegTweaksTmpClear(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createLegTweaksTmpClear(builder, floorClip, skatingCorrection, toeSnap, footPlant) {
        LegTweaksTmpClear.startLegTweaksTmpClear(builder);
        LegTweaksTmpClear.addFloorClip(builder, floorClip);
        LegTweaksTmpClear.addSkatingCorrection(builder, skatingCorrection);
        LegTweaksTmpClear.addToeSnap(builder, toeSnap);
        LegTweaksTmpClear.addFootPlant(builder, footPlant);
        return LegTweaksTmpClear.endLegTweaksTmpClear(builder);
    }
    unpack() {
        return new LegTweaksTmpClearT(this.floorClip(), this.skatingCorrection(), this.toeSnap(), this.footPlant());
    }
    unpackTo(_o) {
        _o.floorClip = this.floorClip();
        _o.skatingCorrection = this.skatingCorrection();
        _o.toeSnap = this.toeSnap();
        _o.footPlant = this.footPlant();
    }
}
exports.LegTweaksTmpClear = LegTweaksTmpClear;
class LegTweaksTmpClearT {
    constructor(floorClip = false, skatingCorrection = false, toeSnap = false, footPlant = false) {
        this.floorClip = floorClip;
        this.skatingCorrection = skatingCorrection;
        this.toeSnap = toeSnap;
        this.footPlant = footPlant;
    }
    pack(builder) {
        return LegTweaksTmpClear.createLegTweaksTmpClear(builder, this.floorClip, this.skatingCorrection, this.toeSnap, this.footPlant);
    }
}
exports.LegTweaksTmpClearT = LegTweaksTmpClearT;
